<template>
  <!-- 集运站管理 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">收获地址管理</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input v-model="filterForm.collectStationName" placeholder="集运站名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="filterForm.status" clearable placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.updateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"/>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-plus"
            label="新增"
            perms="31300"
            type="primary"
            @click="handleAdd"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table :data="stationList" stripe size="mini" style="width: 100%">
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="collectStationName"
        align="center"
        label="集运站名称"
      ></el-table-column>
      <el-table-column
        prop="positions"
        align="center"
        label="状态"
      >
        <template slot-scope="scope">
          {{scope.row.status == 0 ? '启用' : '停用'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        align="center"
        label="最后操作时间"
      ></el-table-column>
      <el-table-column
        fixed="right"
        align="left"
        width="300"
        show-overflow-tooltip
        label="操作"
      >
        <template slot-scope="scope">
          <kt-button
            icon="fa fa-edit"
            label="编辑"
            perms="31301"
            @click="handleEdit(scope.row)"
          />
          <kt-button
            icon="fa fa-trash"
            label="删除"
            perms="31302"
            type="danger"
            @click="handleDelete(scope.row)"
          />
          <kt-button
            v-if="scope.row.status === 1"
            icon="fa fa-check"
            label="启用"
            perms="31303"
            @click="handleEnable(scope.row)"
            type="primary"/>
          <kt-button
            v-else
            icon="fa fa-remove"
            label="停用"
            perms="31303"
            type="danger"
            @click="handleDisable(scope.row)"/>
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      ></el-pagination>
    </div>
    <!-- 新增收获地址弹窗 -->
    <el-dialog
      width="500px"
      label-position="center"
      :title="stationDialogTitle"
      :visible.sync="stationDialogVisible"
      :lock-scroll="true"
      custom-class="dialogClass"
      :close-on-click-modal="false"
      :before-close="handleCloseRole"
    >
      <el-form
        :model="stationForm"
        :rules="stationRules"
        ref="stationForm"
        label-width="100px"
        :size="size"
        class="stationForm"
        @keyup.enter.native="submitstationForm()"
      >
        <el-form-item label="集运站名称" prop="collectStationName">
          <el-input v-model="stationForm.collectStationName" placeholder="请输入集运站名称">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="handleCloseRole">取消</el-button>
        <el-button :size="size" type="primary" @click="submitstationForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
export default {
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      filterForm: {},
      statusList: [
        {name: '启用', code: '0'},
        {name: '禁用', code: '1'}
      ],
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      stationList: [], //员工列表
      stationDialogTitle: '新增',
      stationDialogVisible: false, // 新增编辑员工弹窗
      stationForm: {},
      stationRules: {
        collectStationName: [ { required: true, message: "请输入集运站名称", trigger: "blur" }],
      }
    };
  },
  mounted() {
    this.getStationList();
  },
  methods: {
    // 获取集运站列表
    async getStationList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "updateTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = `${val[0]} 00:00:00`;
            params["searchFieldList[" + index + "].rangeMaxValue"] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.station.mGetStationList(params);
      this.stationList = res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },
    
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getStationList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getStationList();
    },
    // 重置搜索条件
    handleReset() {
      this.filterForm = {

      }
      this.getStationList()
    },
    // 显示新增界面
    handleAdd() {
      this.stationDialogTitle = '新增'
      this.stationDialogVisible = true;
    },

    // 显示编辑界面
    handleEdit(row) {
      this.stationDialogTitle = '编辑'
      this.stationForm = row
      this.stationDialogVisible = true;
    },

    // 关闭弹窗
    handleCloseRole() {
      this.stationDialogVisible = false
      this.stationForm = {};
    },

    // 新增编辑提交
    submitstationForm() {
      this.$refs['stationForm'].validate(async (valid) => {
        if (valid) {
          let addEditstationApi = this.stationForm.collectStationNo
          ? 
          this.$api.station.mEditStation
          : 
          this.$api.station.mAddStation
          let res = await addEditstationApi(this.stationForm)
          this.stationDialogVisible = false
          this.$refs['stationForm'].resetFields()
          this.$message({ message: "保存成功", type: "success" });
          this.getStationList()
        }
      })
    },

    // 删除地址
    handleDelete(row) {
      this.$confirm("确认删除该地址吗？", "提示", {
        type: "warning",
      }).then(async () => {
        let res = await this.$api.station.mDelStation({
          collectStationNo: row.collectStationNo
        })

        if(+res.code === 0){
          this.getStationList();
          this.$message({ message: "删除成功", type: "success" });
        }
      });
    },

    // 启用
    async handleEnable(row){
      let res = await this.$api.station.mGetEnableStation({
        collectStationNo: row.collectStationNo,
      })

      this.getStationList();
      this.$message({ message: "启用成功", type: "success" });
    },

    // 停用
    async handleDisable(row){
      let res = await this.$api.station.mDisableStation({
        collectStationNo: row.collectStationNo,
      })

      this.getStationList();
      this.$message({ message: "停用成功", type: "success" });
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  padding: 10px 10px 30px;
  box-sizing: border-box;
}
</style>